__turbopack_context__.v({
  "background": "CVWOkq_background",
  "backgroundImage": "CVWOkq_backgroundImage",
  "body": "CVWOkq_body",
  "category": "CVWOkq_category",
  "content": "CVWOkq_content",
  "contentSizer": "CVWOkq_contentSizer",
  "copyStack": "CVWOkq_copyStack",
  "cta": "CVWOkq_cta",
  "fg": "CVWOkq_fg",
  "footer": "CVWOkq_footer",
  "hero": "CVWOkq_hero",
  "heroContentIn": "CVWOkq_heroContentIn",
  "highlightedLabel": "CVWOkq_highlightedLabel",
  "navButton": "CVWOkq_navButton",
  "navButtons": "CVWOkq_navButtons",
  "overlay": "CVWOkq_overlay",
  "pageControl": "CVWOkq_pageControl",
  "pageThumb": "CVWOkq_pageThumb",
  "playIcon": "CVWOkq_playIcon",
  "price": "CVWOkq_price",
  "priceAmount": "CVWOkq_priceAmount",
  "priceLabel": "CVWOkq_priceLabel",
  "rail": "CVWOkq_rail",
  "railCard": "CVWOkq_railCard",
  "railCardImg": "CVWOkq_railCardImg",
  "title": "CVWOkq_title",
  "videoSlot": "CVWOkq_videoSlot",
});
